import { render, staticRenderFns } from "./TicketReply.vue?vue&type=template&id=5734482c&scoped=true&"
import script from "./TicketReply.vue?vue&type=script&lang=js&"
export * from "./TicketReply.vue?vue&type=script&lang=js&"
import style0 from "./TicketReply.vue?vue&type=style&index=0&id=5734482c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734482c",
  null
  
)

export default component.exports